module.exports = __webpack_public_path__ + "img/winerackdog00.cffb8a6f.jpg";